var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"help"}},[_c('h2',[_vm._v("Aide")]),_c('p',[_vm._v("Version cineserver: "+_vm._s(_vm.serverversion))]),_c('p',[_vm._v("Version cinegest: "+_vm._s(_vm.$store.state.version))])])}
var staticRenderFns = []

export { render, staticRenderFns }